import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {MatDialog} from "@angular/material/dialog";
import {ProductPreOrderDialogComponent} from "../product-pre-order-dialog/product-pre-order-dialog.component";
import {IProductNotifyStock} from "../../product-details/interface/product-notify-stock";
import {OutOfStockTransmissionService} from "../../raintree/transmission/out-of-stock-transmission.service";
import {ToastMessageService} from "../../services/toast-message.service";
import {ProductNotifyStockDialogComponent} from "../product-notify-stock-dialog/product-notify-stock-dialog.component";
import {JWTService} from "../../authentication/jwt.service";
import {CartLoginPopupComponent} from "../../components-library/cart-login-popup/cart-login-popup.component";

@Component({
	selector: 'fb-product-cart-buttons',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-cart-buttons.component.html',
	styleUrls: ['./product-cart-buttons.component.scss']
})
export class ProductCartButtonsComponent {

	@Input()
	public product: Product = {} as Product;
	@Input()
	public minOrderQuantity: number = 1;

	@Input()
	public calculatedQuantityInStock: number = 0;

	@Input()
	public productId: number = 0;

	@Input()
	public selectedFabricId: number = 0;

	@Input()
	public selectedSizeId: number = 0;

	@Output()
	public addToCart : EventEmitter<void> = new EventEmitter<void>();

	constructor(
		private _dialog: MatDialog,
		private _api: OutOfStockTransmissionService,
		private _toast: ToastMessageService,
		private _jwt: JWTService,
	) {
	}

	private _addOutOfStockNotifyAPI(notify: IProductNotifyStock): void {
		this._api.addOutOfStockNotification(
			notify,
			()=> {},
			()=> {},
			(response)=> {
				if (response.message === '0') {
					this._toast.info(
						"You are already in our waitlist!",
						"We will notify you as soon as the product gets back in stock"
					);
					return;
				}

				this._dialog.open(ProductNotifyStockDialogComponent, {
					id: 'outOfStockDialog',
					maxWidth: '95vw',
					maxHeight: '90vh',
					data: {
						notificationId: response.message,
						product: this.product
					}
				});
			},
			()=> {},
			()=> {}
		)
	}

	private _openSignInDialog(): void {
		this._dialog.open(CartLoginPopupComponent, {
			maxWidth: '600px',
			width: '90vw',
			maxHeight: '85vh'
		});
	}

	public openPreOrderDialog(): void {
		if(this._jwt.hasValidJWT()) {
			this._dialog.open(
				ProductPreOrderDialogComponent, {
					id: 'product-pre-order-dialog',
					data: {
						product: this.product,
						id: this.productId
					},
					width: '100vw',
					maxWidth: '800px',
					height: '100%',
					position: {
						top: '0',
						right: '0'
					}
				});
		}
		else {
			this._openSignInDialog()
		}
	}

	public addProductToCart(): void {
		if(this._jwt.hasValidJWT()) {
			this.addToCart.emit();
		}
		else {
			this._openSignInDialog();
		}

	}

	public notifyOutOfStock() {
		if(this._jwt.hasValidJWT()) {
			let notify = {
				productId: this.product.id,
				madeToOrderProductId: this.selectedFabricId,
				sizeOptionId: this.selectedSizeId,
				status: "PENDING"
			}

			this._addOutOfStockNotifyAPI(notify);
		}
		else  {
			this._openSignInDialog();
		}
	}
}
